import wpUlikeReLoad from './wpUlikeReLoad';
import trigger from './customEvent';

//タイムラインの中にコンテンツを入れる
export default function (timeline, el, appendDistance) {
	let dispYear = timeline.getCurrentYear();
	let dispMonth = timeline.getCurrentMonth();
	const prevEL = document.getElementById('js-prev');
	const nextEL = document.getElementById('js-next');
	const siteurl = document.getElementById('js-page-wrapper').getAttribute('data-siteurl');
	const tlListEl = el;
	axios({
		method: 'get',
		url: siteurl + '/timelineapi/',
		responseType:'document',
		params: {
			yy: dispYear,
			mm: dispMonth,
		},
	})
		.then(function (response) {
			if(appendDistance =='top') {//現在からの未来 next
				const nextItems = response.data.querySelectorAll('#next-month li');
				//次月のデータがあるか
				if(nextItems.length > 0) {
					nextEL.classList.add('is-active');
				} else {
					nextEL.classList.remove('is-active');
				}
			} else if(appendDistance =='bottom') {//過去 prev
				const prevItems = response.data.querySelectorAll('#prev-month li');
				//前月のデータがあるか
				if(prevItems.length > 0) {
					prevEL.classList.add('is-active');
				} else  {
					prevEL.classList.remove('is-active');
				}
			} else {
				const prevItems = response.data.querySelectorAll('#prev-month li');
				const nextItems = response.data.querySelectorAll('#next-month li');
				//前月のデータがあるか
				if(prevItems.length > 0) {
					prevEL.classList.add('is-active');
				} else  {
					prevEL.classList.remove('is-active');
				}
				//次月のデータがあるか
				if(nextItems.length > 0) {
					nextEL.classList.add('is-active');
				} else {
					nextEL.classList.remove('is-active');
				}
			}

			const items = response.data.querySelectorAll('#target-month li');
			const adItems = response.data.querySelectorAll('#target-ad-month li');

			[].forEach.call(items, (item) => {
				const id = item.getAttribute('data-type');
				const el = document.getElementById(id);
				if(el) {
					const dayArea = el.parentNode.querySelector('.c-timeline__day');
					const thumb = item.querySelector('.thumb');
					const event = item.querySelector('.event');
					const title = item.querySelector('.title');
					const myId = item.getAttribute('id');
					if (thumb) {
						thumb.setAttribute('data-id', myId);
						el.appendChild(thumb);
					}
					if (title) {
						el.appendChild(title);
					}
					if (event && dayArea) {
						if(!dayArea.querySelector('.event')) {
							dayArea.appendChild(event);
						}
					}
					const likeBtn = item.querySelector('.wpulike');
					if(likeBtn) {
						el.appendChild(likeBtn);
					}
				} else {
					throw new Error(id+' is null')
				}
			});

			//不要な要素を削除
			const timelineListItems = el.querySelectorAll('.js-timelime__list li');
			[].forEach.call(timelineListItems, (item) => {
				if(!item.querySelector('.title')) {
					item.remove();
				}
			});

			///広告を追加
			[].forEach.call(adItems, (item) => {
				const targetAttValue = 'date-'+item.getAttribute('data-date');
				const target = document.querySelector('[data-id="'+targetAttValue+'"');
				if(target) {
					const targetParent = target.parentNode;
					targetParent.insertBefore(item, target);
				}
			});

			//いいねボタンの JS 際読み込み
			wpUlikeReLoad();

			trigger(window, 'timelineReady', {el: el, distance: appendDistance});

			let imgLoadCounter = 0;
			const imgs = tlListEl.querySelectorAll('.thumb img');
			const imgsLen = imgs.length;
			[].forEach.call(imgs, (img) => {
				img.onload = function(e) {
					imgLoadCounter += 1;
					e.target.closest('.js-timeline-item').classList.add('is-ready');
					if(imgLoadCounter >= imgsLen) {
						trigger(window, 'loadingEnd');
						trigger(window, 'timelineLoaded');
					}
				}
			});

			if(items.length <= 0) {
				trigger(window, 'loadingEnd');
				console.log("aritcle count 0");
			}
		})
		.catch(function (error) {
			console.log(error);
		})
		.then(function () {
		}
	);
}
